const model = {
    submitting: false,
    errors: null,
    warehouseDetails: null,
    success: false,
};

export default model;
